export const WEBSOCKET_TOPIC_POSITIONS = '/topic/positions';
export const WEBSOCKET_TOPIC_STATUSES_BY_SIDE_NUMBER = '/topic/statuses/';
export const WEBSOCKET_TOPIC_STATUSES_DEVICE_TYPE = '/topic/statuses/deviceType/';
export const WEBSOCKET_LIVE_DATA_REPORT_TOPIC_V2 = '/topic/liveDataReport/v2';
export const WEBSOCKET_TOPIC_USER_FILES = '/topic/files/';
export const WEBSOCKET_TOPIC_USERS_CONNECTION_STATE = '/topic/usersState';
export const WEBSOCKET_TOPIC_USERS_LOGIN_STATE = '/topic/usersLogin';
export const WEBSOCKET_TOPIC_SNVR_TASK = '/topic/snvr/task';
export const TOPIC_SNVR_UPDATE_RECORDINGS_CONTINUITY = '/topic/snvr/recordings';
export const ARCHIVE_TENANT = 'stp_archive';
export const EMPTY_NUMBER_VALUE = 65535;
export const WEBSOCKET_TOPIC_PHANTOMS = '/topic/GPSFrameWithApproximatedActualStopPile';
export const WEBSOCKET_USER_SNAPSHOTFILE = '/topic/snapshot/file/receive/user/';
export const WEBSOCKET_TOPIC_MESSAGES = '/topic/messages';
export const WEBSOCKET_TOPIC_MESSAGES_UNREAD = '/topic/messages/unread';
export const WEBSOCKET_TOPIC_ZONE_EVENTS = '/topic/zoneEvents';

export const RECEIVE_TIME = 'receiveTime';
export const RECEIVE_TIME_SC = 'receive_time';
export const EVENT_OCCERRENCE_TIME_SC = 'eventOccurrenceTime';

export const WEBSOCKET_TOPIC_ALCOHOL_TEST_REQUEST_DELIVERED = '/topic/alcohol-test-request/delivered';
export const WEBSOCKET_TOPIC_VEHICLE_EMERGENCY = '/topic/vehicle/emergency';
export const WEBSOCKET_TOPIC_JANUS_PIPELINE_STATUS = '/topic/chat/vehicle/pipeline';

